import { useState } from "react";
import BackgroundGradient from "@/components/landing/BackgroundGradient";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import ContactModal from "@/components/landing/ContactModal";
import SEO from "@/components/SEO";

export default function Privacy() {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
    <BackgroundGradient />
    <div style={{ minHeight: "100vh", color: "var(--dyna-fg)", position: "relative", zIndex: 1 }}>
      <SEO
        title="Privacy Policy — Dyna Agency"
        description="How Dyna Agency collects, uses, and protects your personal information."
        path="/privacy"
      />
      <Navbar onCTA={() => setModalOpen(true)} />
      <main style={{ paddingTop: 100 }}>
        <div className="dyna-policy-page">

          <h1>Privacy Policy</h1>
          <span className="dyna-policy-updated">Last updated: April 2026</span>

          <div className="dyna-policy-section">
            <h2>1. Who We Are</h2>
            <p>
              Dyna Agency is operated by Pinch and Ezra, based in Jerusalem, Israel.
              We provide web design and SEO/GEO services to clients worldwide.
            </p>
            <p>
              Contact:{" "}
              <a href="mailto:hello@dyna-agency.com">hello@dyna-agency.com</a>
              {" "}|{" "}
              <a href="https://www.dyna-agency.com" target="_blank" rel="noopener noreferrer">
                www.dyna-agency.com
              </a>
            </p>
          </div>

          <div className="dyna-policy-section">
            <h2>2. Information We Collect</h2>
            <ul>
              <li>Name, email, and phone from contact and booking forms</li>
              <li>Business name, website URL, and business information from onboarding</li>
              <li>Usage data via Google Analytics (pages visited, time on site, browser type)</li>
              <li>Authentication data via Google OAuth</li>
            </ul>
          </div>

          <div className="dyna-policy-section">
            <h2>3. How We Use Your Information</h2>
            <ul>
              <li>Deliver the services you requested</li>
              <li>Communicate about your project and account</li>
              <li>Send updates, reports, and billing information</li>
              <li>Marketing communications (with consent — opt out any time)</li>
              <li>Improve our website and services</li>
            </ul>
          </div>

          <div className="dyna-policy-section">
            <h2>4. Legal Basis</h2>
            <p>
              Our privacy practices are governed by the Israeli Privacy Protection Law
              5741-1981. For clients based in the United States, we comply with applicable
              US privacy laws including state-level requirements where applicable.
            </p>
          </div>

          <div className="dyna-policy-section">
            <h2>5. Third-Party Services</h2>
            <ul>
              <li><strong>Google Analytics</strong> — website analytics and usage tracking</li>
              <li><strong>Google OAuth</strong> — authentication</li>
              <li><strong>Stripe</strong> — payment processing</li>
              <li><strong>Email service providers</strong> — transactional and marketing emails</li>
            </ul>
            <p>
              Each of these services has its own privacy policy. We recommend reviewing
              them if you have questions about how your data is handled downstream.
            </p>
          </div>

          <div className="dyna-policy-section">
            <h2>6. Data Retention</h2>
            <ul>
              <li>Active client data: duration of engagement plus 3 years</li>
              <li>Lead / prospect data: up to 2 years</li>
            </ul>
            <p>
              You can request deletion of your data at any time by emailing{" "}
              <a href="mailto:hello@dyna-agency.com">hello@dyna-agency.com</a>.
            </p>
          </div>

          <div className="dyna-policy-section">
            <h2>7. Your Rights</h2>
            <p>
              You have the right to access, correct, or delete the personal data we hold
              about you, and to opt out of marketing communications at any time. To
              exercise any of these rights, contact us at{" "}
              <a href="mailto:hello@dyna-agency.com">hello@dyna-agency.com</a>.
            </p>
          </div>

          <div className="dyna-policy-section">
            <h2>8. Cookies</h2>
            <p>
              We use cookies to operate the site and understand usage. For full details
              on what cookies we set and how to manage them, see our{" "}
              <a href="/cookies">Cookie Policy</a>.
            </p>
          </div>

          <div className="dyna-policy-section">
            <h2>9. Changes to This Policy</h2>
            <p>
              We may update this policy from time to time. Significant changes will be
              communicated by email or a notice on the site. Continued use of our services
              after changes are posted constitutes your acceptance of the updated policy.
            </p>
          </div>

          <div className="dyna-policy-section">
            <h2>10. Contact</h2>
            <p>
              Dyna Agency<br />
              Jerusalem, Israel<br />
              <a href="mailto:hello@dyna-agency.com">hello@dyna-agency.com</a>
              {" "}|{" "}
              <a href="https://www.dyna-agency.com" target="_blank" rel="noopener noreferrer">
                www.dyna-agency.com
              </a>
            </p>
          </div>

        </div>
      </main>
      <Footer />
    </div>
    <ContactModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
